import type { AdvancementOptions } from "@/types"

// ── Advancement rules ─────────────────────────────────────────────────────────
//
// Pure encoding of the BB 2025 advancement-unlock table, mirrored client-side
// from the server's Advancements::ApplyForm validation. Given a 2D6 roll, it
// decides which skill categories and stat improvements a coach may choose. A
// drift here would show coaches options the server rejects, so the mapping is
// pinned by advancement-rules.test.ts.

export const CATEGORY_LABELS: Record<string, string> = {
  agility: "Agility",
  devious: "Devious",
  general: "General",
  mutation: "Mutation",
  passing: "Passing",
  strength: "Strength",
}

export function getAvailableForRoll(roll: number, options: AdvancementOptions) {
  const {
    primary_categories,
    secondary_categories,
    skills_by_category,
    stat_improvements,
  } = options

  let unlockedCategories: string[]
  if (roll >= 12) {
    unlockedCategories = [
      ...new Set([
        ...primary_categories,
        ...secondary_categories,
        ...Object.keys(skills_by_category),
      ]),
    ]
  } else if (roll >= 8) {
    unlockedCategories = [
      ...new Set([...primary_categories, ...secondary_categories]),
    ]
  } else {
    unlockedCategories = [...primary_categories]
  }

  return {
    unlockedCategories,
    includeStats: roll >= 10,
    availableStats: roll >= 10 ? stat_improvements : [],
  }
}

export function labelForRoll(roll: number): string {
  if (roll >= 12) return "Any Skill"
  if (roll >= 10) return "Skill or Stat"
  if (roll >= 8) return "Primary or Secondary"
  return "Primary Skill"
}
